import { useEffect } from "react";
import { identity } from "../utilities/fp";
import { useSyncExternalStore } from "../utilities/hooks/useSyncExternalStore";

export function useLocalStorageState(key, initialValue, options = {}) {
  options = {
    transform: identity,
    enableInit: false,
    ...options,
  };

  const getSnapshot = () => options.transform(localStorage.getItem(key));

  const setState = (newValue) => {
    if (typeof newValue === "function") {
      newValue = newValue(getSnapshot());
    }
    localStorage.setItem(key, newValue);
    dispatchEvent(new StorageEvent("storage", { key, newValue }));
  };

  const subscribe = (listener) => {
    window.addEventListener("storage", listener);
    return () => void window.removeEventListener("storage", listener);
  };

  const value = useSyncExternalStore(subscribe, getSnapshot);

  useEffect(() => {
    if (options.enableInit) {
      setState(initialValue);
    }
  }, []);

  return [value, setState];
}
